module.exports = __webpack_public_path__ + "img/MC-Logo-combined.2638d90.png";